import { t } from '@lingui/macro'
import { Center, Spinner } from 'front-end/src/components'
import React, { useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { staticLinks } from 'shared/linkBuilder'

import { notification } from '../components/common/notifications/Notifications'
import { apolloClientPrivate } from '../graphql/apolloClient'
import { useSelfSignupWithSecretLinkForLoggedInUserMutation } from './SelfSignupWithSecretLinkForLoggedInUser.codegen'

export const useSelfSignupWithSecretLinkForLoggedInUserAction = () => {
  const [SelfSignup] = useSelfSignupWithSecretLinkForLoggedInUserMutation({
    client: apolloClientPrivate
  })
  const history = useHistory()

  return async (token: string) => {
    const { data } = await SelfSignup({
      variables: {
        token
      }
    })
    if (data?.organisation.secretSelfSignupLink?.addCurrentUserToGroup?.role) {
      notification.info(
        t`You've been added to "${data?.organisation.secretSelfSignupLink?.group?.name}" group`
      )
    } else {
      notification.info(
        t`You are already member of "${data?.organisation.secretSelfSignupLink?.group?.name}" group`
      )
    }

    history.replace(staticLinks.home)
  }
}

export const SelfSignupWithSecretLinkForLoggedInUser = () => {
  const params = useParams<{
    token: string
  }>()
  const action = useSelfSignupWithSecretLinkForLoggedInUserAction()

  useEffect(() => {
    action(params.token)
  }, [])

  return (
    <Center>
      <Spinner />
    </Center>
  )
}
